"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bregano": {
    "6cbb2ef8": [{
      "hkey": "02e09703",
      "slug": "bardello-con-malgesso-e-bregano",
      "name": "Bardello con Malgesso e Bregano",
      "primary": true,
      "skipSearch": false
    }],
    "bregano": [{
      "hkey": "02e09703",
      "slug": "bardello-con-malgesso-e-bregano",
      "name": "Bardello con Malgesso e Bregano",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;